import * as React from 'react';
import LoadingIndicator from 'components/LoadingIndicator';

export default function OrganizationPickerSelectedLoadingItem() {
  return (
    <div className="OrganizationPickerSelectedItem OrganizationPickerSelectedItem--loading">
      <LoadingIndicator />
    </div>
  );
}
